import type { AxiosError } from 'axios'
import { filter, mergeMap, of } from 'rxjs'
import { catchError, retryWhen, withLatestFrom } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { errorMessage, successMessage } from '../../../../Model/Message/IMessage.js'
import type { Epic } from '../../../index.js'
import { withBlockingRequest } from '../../Application/withBlockingRequest.js'
import { addMessage } from '../../../Slice/Application/ApplicationSlice.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import { getErrorMessage } from './submitPostprocessingError.js'

export const SUBMIT_POSTPROCESSING_BLOCKING_ID = 'submit-postprocessing'

export const SubmitPostprocessingEpic: Epic = (action$, state$, { OrderRepository, [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.submitPostprocessingRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      withBlockingRequest(
        OrderRepository.forceSubmitOrder(action.payload, state.authentication.user).pipe(
          mergeMap((response) => of(order.submitPostprocessingSuccess(response), addMessage(successMessage('Postprocessing started')))),
          retryWhen(serverIsNotAvailable()),
          catchError((error: AxiosError) =>
            of(order.submitPostprocessingFailure({ error: getErrorMessage(error) }), addMessage(errorMessage(getErrorMessage(error))))
          )
        ),
        'Starting Postprocessing',
        'Please wait while the order is submitted to postprocessing',
        SUBMIT_POSTPROCESSING_BLOCKING_ID
      )
    )
  )
